import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddGovtRateList = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [discom, setDiscom] = useState([]);
  const [discomId, setDiscomId] = useState("");
  const [region, setRegion] = useState([]);
  const [regionId, setRegionId] = useState("");
  const [storeProduct, setStoreProduct] = useState([]);
  const [productName, setProductName] = useState("");

  const [rowAddData, setRowAddData] = useState({
    circle_name: "",
    govt_rate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleProductChange = (e) => {
    setProductName(e.target.value);
  };

  const handleDiscomChange = (e) => {
    const value = e.target.value;
    setDiscomId(value ? value : "");
    setRegion([]);
    setRegionId("");
  };

  const handleRegionChange = (e) => {
    setRegionId(e.target.value);
  };

  function resetFields() {
    setRowAddData({
    circle_name: "",
    govt_rate: "",
    });
    setDiscomId("");
    setProductName("");
    setRegionId("")
    setRegion([])
  }

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const { circle_name, govt_rate } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/govt-rate/govt-rate-list/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        discom_id: discomId,
        region_id: regionId,
        circle_name,
        product_name: productName,
        govt_rate,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
        formRef.current.reset();
      }, 1000);
      getData();
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getDiscom = async () => {
    const BASE_URL = SERVER_URL + `/api/discom/all-discoms/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setDiscom(result.data);
  };

  useEffect(() => {
    getDiscom();
  }, []);

  const getRegion = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/region/drop-region-list/${user_id}?discom_id=${discomId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setRegion(result.data);
  };

  useEffect(() => {
    if (discomId) {
      getRegion();
    }
  }, [discomId]);

  const getProductData = async () => {
    let BASE_URL = SERVER_URL + `/api/product/all-products-distinct/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreProduct(result.data);
    } else {
      setStoreProduct([]);
    }
  };

  useEffect(() => {
    getProductData();
  }, [productName]);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Circle & Region
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="discom">Discom Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleDiscomChange}
                              value={discomId}
                              id="discom"
                              required
                            >
                              <option value="">Select Discom</option>
                              {discom &&
                                discom?.length > 0 &&
                                discom?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.discom_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="region">Region Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleRegionChange}
                              value={regionId}
                              id="region"
                              required
                            >
                              <option value="">Select Region</option>
                              {region &&
                                region?.length > 0 &&
                                region?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.region_name}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="circle_name">Circle Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="circle_name"
                              id="circle_name"
                              placeholder="Enter Circle Name"
                              value={rowAddData.circle_name}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="Pole">Size</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="company_id"
                              id="company_id"
                              onChange={handleProductChange}
                              value={productName}
                              required
                            >
                              <option value="">Select Size</option>
                              {storeProduct &&
                                storeProduct.length > 0 &&
                                storeProduct?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.size}
                                      key={id}
                                    >{`${item.size}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="govt_rate">Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="govt_rate"
                              id="govt_rate"
                              placeholder="Enter Rate"
                              value={rowAddData.govt_rate}
                              onChange={handleChange}
                              required
                              autoComplete="off"
                              min="0"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddGovtRateList;
